import useSWR from 'swr'
import { get } from '@/utils/request'
import { commonSWROptions } from './useAdmin'

const getPenalties = (match_id) =>
  get('users/penalties/match_penalties', { match_id }).then((res) => {
    if (res.ok) {
      return res.penalties
    }
    return []
  })

const usePenalties = (match_id, is_login) => {
  return useSWR(is_login ? `penalties-${match_id}` : undefined, () => getPenalties(match_id), { ...commonSWROptions, fallbackData: [] }) as {
    data: any[]
    mutate: any
    isValidating: boolean
  }
}

export default usePenalties
